import React from "react";

const BS5_Popover = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Popover Component</h2>
      <p>This is the BS5_Popover component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Popover;
